import { Box, FormControlLabel, Radio, Stack, TextField, Typography } from "@mui/material";

import { parseBox18aAmount } from "./resolveBox18a";

export const BOX_18A_HELPER = "From Box 18a on the e-Manifest. Enter pounds.";
export const BOX_18A_INVALID_AMOUNT = "Enter pounds above 0.";

/** "Box 18a amount": a radio with the received-pounds input on the same line; focusing the input picks it. */
export function Box18aAmountOption(props: {
  amount: string;
  selected: boolean;
  disabled: boolean;
  /** Why the option is unavailable, shown under the input, or null. */
  reason: string | null;
  onAmountChange: (value: string) => void;
  onSelect: () => void;
}) {
  const { amount, selected, disabled, reason } = props;
  // Save stays disabled for these, so say why next to the input.
  const invalid = amount.trim() !== "" && parseBox18aAmount(amount) == null;
  return (
    <Box sx={{ mx: 0, py: 0.25 }}>
      <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ py: 0.5 }}>
        <FormControlLabel
          value="BOX_18A"
          disabled={disabled}
          sx={{ mx: 0, flexShrink: 0, mt: 0.5 }}
          control={<Radio size="small" />}
          label={
            <Typography
              variant="body2"
              fontWeight={700}
              color={disabled ? "text.disabled" : undefined}
            >
              Box 18a amount
            </Typography>
          }
        />
        <TextField
          label="Received amount (lb)"
          type="number"
          size="small"
          fullWidth
          disabled={disabled}
          value={amount}
          error={invalid && !disabled}
          helperText={reason ?? (invalid ? BOX_18A_INVALID_AMOUNT : BOX_18A_HELPER)}
          onChange={(e) => props.onAmountChange(e.target.value)}
          onFocus={() => {
            if (!selected && !disabled) props.onSelect();
          }}
        />
      </Stack>
    </Box>
  );
}
